<div class="flex flex-col mx-3" *lohiFeatureFlag="'migrationMapNewsFeed'">
  <div class="flex flex-col md:flex-row gap-4">
    <div class="w-full md:w-1/3 py-2 mt-1" style="height: fit-content">
      <div class="bg-white card-with-shadow">
        <div class="text-lg font-bold border-b border-gray-400">
          <div class="p-2">Activity Report</div>
        </div>
        <div class="p-2 w-full flex flex-col" *ngIf="fracsActivity$ | async as fracActivityReportPerRegions">
          <mat-form-field>
            <mat-select [value]="selectedFracActivity$$ | async" (valueChange)="selectFracActivity($event)">
              <mat-option
                [value]="region"
                *ngFor="let region of fracActivityReportPerRegions; trackBy: 'id' | trackByKey"
              >
                {{ region.regionName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
            <div *ngIf="selectedFracActivity.fracsRunningToday?.length + selectedFracActivity.fracsDown?.length">
              <div class="text-lg font-bold py-2">Loads Per Day</div>
              <div class="flex flex-row gap-2">
                <div class="card-with-shadow-4px-radius bg-white border border-gray-400 w-1/2 p-2">
                  <div class="text-gray-500">High performing trucks could do:</div>
                  <div class="text-2xl font-bold mt-1">3 Loads</div>
                </div>
                <div class="card-with-shadow-4px-radius bg-white border border-gray-400 w-1/2 p-2">
                  <div class="text-gray-500">The average turn rate is:</div>
                  <div class="text-2xl font-bold mt-1">
                    <ng-container *ngIf="selectedFracActivity.avgTurnRate > 0; else dash">
                      {{ selectedFracActivity.avgTurnRate | number: '1.0-1' }} Loads
                    </ng-container>
                    <ng-template #dash>-</ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-with-shadow bg-white">
        <div class="text-lg font-bold border-b border-gray-400">
          <div class="p-2">Affecting Your Loads Per Day</div>
        </div>
        <div class="p-2 w-full flex flex-col">
          <div *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
            <div *ngIf="selectedFracActivity.fracsRunningToday?.length + selectedFracActivity.fracsDown?.length">
              <span>
                Out of
                {{ selectedFracActivity.fracsRunningToday?.length + selectedFracActivity.fracsDown?.length }}
                crews pumping in the region:
              </span>
              <div class="flex flex-col gap-1 mt-2">
                <div class="flex flex-row items-center" *ngIf="selectedFracActivity.fracsRunningToday?.length > 0">
                  <div class="mr-2">
                    <img class="" src="../../../assets/images/tick-green.svg" />
                  </div>
                  <div class="col-span-3" [ngPlural]="selectedFracActivity.fracsRunningToday?.length">
                    {{ selectedFracActivity.fracsRunningToday?.length | number }}
                    <ng-template ngPluralCase="=1">well</ng-template>
                    <ng-template ngPluralCase="other">wells</ng-template>
                    running today
                  </div>
                </div>
                <div class="flex flex-row items-center" *ngIf="selectedFracActivity.fracsPumpingSlower?.length > 0">
                  <div class="mr-2">
                    <img class="" src="../../../assets/images/info-black.svg" />
                  </div>
                  <div class="col-span-3" [ngPlural]="selectedFracActivity.fracsPumpingSlower?.length">
                    {{ selectedFracActivity.fracsPumpingSlower?.length | number }}
                    <ng-template ngPluralCase="=1">well</ng-template>
                    <ng-template ngPluralCase="other">wells</ng-template>
                    pumping slower than expected
                  </div>
                </div>
                <div class="flex flex-row items-center" *ngIf="selectedFracActivity.fracsDown?.length > 1">
                  <div class="mr-2">
                    <img class="" src="../../../assets/images/info-black.svg" />
                  </div>
                  <div class="col-span-3" [ngPlural]="selectedFracActivity.fracsDown?.length">
                    {{ selectedFracActivity.fracsDown?.length | number }}
                    <ng-template ngPluralCase="=1">well</ng-template>
                    <ng-template ngPluralCase="other">wells</ng-template>
                    down
                  </div>
                </div>
                <div class="flex flex-row items-center" *ngIf="selectedFracActivity.fracsLongWaitTimes?.length > 0">
                  <div class="mr-2">
                    <img class="" src="../../../assets/images/pie-chart-orange.svg" />
                  </div>
                  <div class="col-span-3" [ngPlural]="selectedFracActivity.fracsLongWaitTimes?.length">
                    {{ selectedFracActivity.fracsLongWaitTimes?.length | number }}
                    <ng-template ngPluralCase="=1">well</ng-template>
                    <ng-template ngPluralCase="other">wells</ng-template>
                    with long wait times, currently
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full flex flex-col">
          <mat-tab-group>
            <mat-tab label="Fracs Running">
              <div class="flex flex-col border-t-2 border-gray-400">
                <div
                  class="card-with-shadow flex flex-col bg-white rounded overflow-y-auto divide-y divide-gray-400 p-2 gap-1"
                >
                  <ng-container *lohiFeatureFlag="'qualifiedDriversActivityReport'; else allActivityReportInfo">
                    <div class="flex flex-col">
                      <div class="text-lg font-bold mb-2">Qualifying Fracs</div>
                      <ng-container *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
                        <ng-container
                          *ngIf="
                            fracsActivityWithQualifiedInfo$ | async as fracActivityReportPerRegionWithQualifiedInfo
                          "
                        >
                          <lohi-frac-activity-info
                            class="flex-1"
                            [displayType]="'table'"
                            [fracStatus]="'running'"
                            [title]=""
                            [fracActivityInfo]="
                              getActivityReportByRegionId(
                                fracActivityReportPerRegionWithQualifiedInfo.qualifiedFracs,
                                selectedFracActivity.regionId
                              )?.fracsRunningToday || []
                            "
                          ></lohi-frac-activity-info>
                        </ng-container>
                      </ng-container>
                    </div>
                    <div class="flex flex-col">
                      <div class="flex flex-row my-2 gap-1">
                        <div class="text-lg font-bold">Non-Qualifying Fracs</div>
                        <mat-icon
                          class="text-gray-600 self-end"
                          matTooltip="Your drivers don't have experience with the trailers required for these sites"
                        >
                          info_outline
                        </mat-icon>
                      </div>
                      <ng-container *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
                        <ng-container
                          *ngIf="
                            fracsActivityWithQualifiedInfo$ | async as fracActivityReportPerRegionWithQualifiedInfo
                          "
                        >
                          <lohi-frac-activity-info
                            class="flex-1"
                            [displayType]="'table'"
                            [fracStatus]="'running'"
                            [title]=""
                            [fracActivityInfo]="
                              getActivityReportByRegionId(
                                fracActivityReportPerRegionWithQualifiedInfo.nonQualifiedFracs,
                                selectedFracActivity.regionId
                              )?.fracsRunningToday || []
                            "
                          ></lohi-frac-activity-info>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-template #allActivityReportInfo>
                    <div class="flex flex-col">
                      <ng-container *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
                        <lohi-frac-activity-info
                          class="flex-1"
                          [displayType]="'table'"
                          [fracStatus]="'running'"
                          [title]=""
                          [fracActivityInfo]="selectedFracActivity.fracsRunningToday || []"
                        ></lohi-frac-activity-info>
                      </ng-container>
                    </div>
                  </ng-template>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Fracs Down">
              <div class="flex flex-col border-t-2 border-gray-400">
                <div
                  class="card-with-shadow flex flex-col bg-white rounded overflow-y-auto divide-y divide-gray-400 p-2 gap-1"
                >
                  <ng-container *lohiFeatureFlag="'qualifiedDriversActivityReport'; else allActivityReportInfo">
                    <div class="flex flex-col">
                      <div class="text-lg font-bold mb-2">Qualifying Fracs</div>
                      <ng-container *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
                        <ng-container
                          *ngIf="
                            fracsActivityWithQualifiedInfo$ | async as fracActivityReportPerRegionWithQualifiedInfo
                          "
                        >
                          <lohi-frac-activity-info
                            class="flex-1"
                            [displayType]="'table'"
                            [fracStatus]="'down'"
                            [title]=""
                            [fracActivityInfo]="
                              getActivityReportByRegionId(
                                fracActivityReportPerRegionWithQualifiedInfo.qualifiedFracs,
                                selectedFracActivity.regionId
                              )?.fracsDown || []
                            "
                          ></lohi-frac-activity-info>
                        </ng-container>
                      </ng-container>
                    </div>
                    <div class="flex flex-col">
                      <div class="flex flex-row my-2 gap-1">
                        <div class="text-lg font-bold">Non-Qualifying Fracs</div>
                        <mat-icon
                          class="text-gray-600 self-end"
                          matTooltip="Your drivers don't have experience with the trailers required for these sites"
                        >
                          info_outline
                        </mat-icon>
                      </div>
                      <ng-container *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
                        <ng-container
                          *ngIf="
                            fracsActivityWithQualifiedInfo$ | async as fracActivityReportPerRegionWithQualifiedInfo
                          "
                        >
                          <lohi-frac-activity-info
                            class="flex-1"
                            [displayType]="'table'"
                            [fracStatus]="'down'"
                            [title]=""
                            [fracActivityInfo]="
                              getActivityReportByRegionId(
                                fracActivityReportPerRegionWithQualifiedInfo.nonQualifiedFracs,
                                selectedFracActivity.regionId
                              )?.fracsDown || []
                            "
                          ></lohi-frac-activity-info>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-template #allActivityReportInfo>
                    <div class="flex flex-col">
                      <ng-container *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
                        <lohi-frac-activity-info
                          class="flex-1"
                          [displayType]="'table'"
                          [fracStatus]="'down'"
                          [title]=""
                          [fracActivityInfo]="selectedFracActivity.fracsDown || []"
                        ></lohi-frac-activity-info>
                      </ng-container>
                    </div>
                  </ng-template>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Fracs Upcoming">
              <div class="flex flex-col border-t-2 border-gray-400">
                <div
                  class="card-with-shadow flex flex-col bg-white rounded overflow-y-auto divide-y divide-gray-400 p-2 gap-1"
                >
                  <ng-container *lohiFeatureFlag="'qualifiedDriversActivityReport'; else allActivityReportInfo">
                    <div class="flex flex-col">
                      <div class="text-lg font-bold mb-2">Qualifying Fracs</div>
                      <ng-container *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
                        <ng-container
                          *ngIf="
                            fracsActivityWithQualifiedInfo$ | async as fracActivityReportPerRegionWithQualifiedInfo
                          "
                        >
                          <lohi-frac-activity-info
                            class="flex-1"
                            [displayType]="'table'"
                            [fracStatus]="'soon'"
                            [title]=""
                            [fracActivityInfo]="
                              getActivityReportByRegionId(
                                fracActivityReportPerRegionWithQualifiedInfo.qualifiedFracs,
                                selectedFracActivity.regionId
                              )?.fracsStartingSoon || []
                            "
                          ></lohi-frac-activity-info>
                        </ng-container>
                      </ng-container>
                    </div>
                    <div class="flex flex-col">
                      <div class="flex flex-row my-2 gap-1">
                        <div class="text-lg font-bold">Non-Qualifying Fracs</div>
                        <mat-icon
                          class="text-gray-600 self-end"
                          matTooltip="Your drivers don't have experience with the trailers required for these sites"
                        >
                          info_outline
                        </mat-icon>
                      </div>
                      <ng-container *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
                        <ng-container
                          *ngIf="
                            fracsActivityWithQualifiedInfo$ | async as fracActivityReportPerRegionWithQualifiedInfo
                          "
                        >
                          <lohi-frac-activity-info
                            class="flex-1"
                            [displayType]="'table'"
                            [fracStatus]="'soon'"
                            [title]=""
                            [fracActivityInfo]="
                              getActivityReportByRegionId(
                                fracActivityReportPerRegionWithQualifiedInfo.nonQualifiedFracs,
                                selectedFracActivity.regionId
                              )?.fracsStartingSoon || []
                            "
                          ></lohi-frac-activity-info>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-template #allActivityReportInfo>
                    <div class="flex flex-col">
                      <ng-container *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
                        <lohi-frac-activity-info
                          class="flex-1"
                          [displayType]="'table'"
                          [fracStatus]="'soon'"
                          [title]=""
                          [fracActivityInfo]="selectedFracActivity.fracsStartingSoon || []"
                        ></lohi-frac-activity-info>
                      </ng-container>
                    </div>
                  </ng-template>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>

    <div class="w-full md:w-2/3">
      <div class="flex text-center py-2 mt-3 bg-white card-with-shadow">
        <mat-select [formControl]="regionsFilterControl">
          <mat-option [value]="'all'">All Regions</mat-option>
          <mat-option
            [value]="region.beamerSegmentFilter"
            *ngFor="let region of regions$ | async; trackBy: 'id' | trackByKey"
          >
            {{ region.name }}
          </mat-option>
        </mat-select>
      </div>
      <ng-container *ngIf="safeNewsFeedUrl" class="pb-10">
        <iframe class="card-with-shadow w-full" style="height: 80vh" [src]="safeNewsFeedUrl"></iframe>
      </ng-container>
    </div>
  </div>
</div>
